import {
    HistoryFullReportData,
    RawOtherEvent,
    ReportCrashEntry,
    ReportOwnerEntry,
    TechInspectionEvent
} from "../api/types";

export const normalizeHistoryFullReportData = (
    data: Partial<HistoryFullReportData>
): HistoryFullReportData => {
    return {
        id: data.id ?? "",
        brand: data.brand ?? "",
        model: data.model ?? "",
        generation: data.generation ?? "",
        color: data.color ?? "",
        horsePower: data.horsePower ?? 0,
        category: data.category ?? "",
        maxWeight: data.maxWeight ?? 0,
        minWeight: data.minWeight ?? 0,
        year: data.year ?? 0,
        bodyNumber: data.bodyNumber ?? "",
        engineNumber: data.engineNumber ?? "",
        crashes: data.crashes ?? false,
        ownersCount: data.ownersCount ?? 1,
        actualRegNumber: data.actualRegNumber ?? "",
        vin: data.vin ?? "",
        bodyType: data.bodyType ?? "",
        driveType: data.driveType ?? "",
        wheel: data.wheel ?? "",
        engineType: data.engineType ?? "",
        transmission: data.transmission ?? "",
        displacement: data.displacement ?? 0,
        doorsCount: data.doorsCount ?? 0,
        ptsType: data.raw?.data?.ptsType ?? null,
        hasFines: Boolean(data.fines),
        accidents: {
            requestTime: data.raw?.data?.accidents?.requestTime ?? 0,
            crashesHistory: Array.isArray(data.raw?.data?.accidents?.crashesHistory)
                ? data.raw.data.accidents.crashesHistory.map((item: Partial<ReportCrashEntry>) => ({
                      date: item.date ?? 0,
                      type: item.type ?? "",
                      region: item.region ?? "",
                      damageMap: item.damageMap ?? [],
                      additional: item.additional ?? [],
                      damageTypes: item.damageTypes ?? []
                  }))
                : []
        },
        ownersHistory: Array.isArray(data.ownersHistory)
            ? data.ownersHistory.map(
                  (owner): ReportOwnerEntry => ({
                      type: owner.type ?? 0,
                      owner: owner.owner ?? "",
                      title: owner.title ?? "",
                      period: owner.period ?? "",
                      region: owner.region ?? ""
                  })
              )
            : [],
        techInspectionHistory: {
            events: Array.isArray(data.techInspectionHistory?.events)
                ? data.techInspectionHistory!.events.map(
                      (event): TechInspectionEvent => ({
                          startDate: event.startDate ?? 0,
                          endDate: event.endDate ?? 0,
                          mileage: event.mileage ?? 0,
                          cardNumber: event.cardNumber ?? ""
                      })
                  )
                : []
        },
        pledge: {
            text: data.pledge?.text ?? "",
            status: data.pledge?.status ?? "unknown",
            requestTime: data.pledge?.requestTime ?? 0
        },
        registration: {
            text: data.registration?.text ?? "",
            status: data.registration?.status ?? "unknown",
            requestTime: data.registration?.requestTime ?? 0
        },
        stealing: {
            text: data.stealing?.text ?? "",
            status: data.stealing?.status ?? "unknown",
            requestTime: data.stealing?.requestTime ?? 0
        },
        taxiData: {
            events: Array.isArray(data.taxiData?.events) ? data.taxiData!.events : null,
            recaps: Array.isArray(data.taxiData?.recaps)
                ? data.taxiData!.recaps.map((r) => ({
                      type: r?.type ?? "",
                      label: r?.label ?? "",
                      status: r?.status ?? "unknown",
                      description: r?.description ?? null
                  }))
                : []
        },
        carsharingData: {
            events: Array.isArray(data.carsharingData?.events) ? data.carsharingData!.events : null,
            recaps: Array.isArray(data.carsharingData?.recaps)
                ? data.carsharingData!.recaps.map((r) => ({
                      type: r?.type ?? "",
                      label: r?.label ?? "",
                      status: r?.status ?? "unknown",
                      description: r?.description ?? null
                  }))
                : []
        },
        insurancePayments: data?.raw?.data?.insurancePayments ?? null,
        salvageCarAuctionRecords: data?.raw?.data?.salvageCarAuctionRecords ?? [],
        createdAt: data.createdAt ?? "",
        historyMileage: Array.isArray(data.historyMileage) ? data.historyMileage : null,
        eventsOthersHistory: Array.isArray(data.raw?.data?.eventsOthersHistory)
            ? data?.raw?.data?.eventsOthersHistory?.map((item: RawOtherEvent) => ({
                  date: item?.date ?? 0,
                  type: item?.type ?? "",
                  event: item?.event ?? "",
                  source: item?.source ?? "",
                  mileage: item?.mileage ?? 0,
                  description: item?.description ?? ""
              }))
            : [],
        fines: data.fines ?? null,
        insurancePolicies: {
            events: data.insurancePolicies?.events ?? [],
            recaps: data.insurancePolicies?.recaps ?? []
        },
        leasing: data?.raw?.data?.leasing ?? null,
        ptsData: data?.raw?.data?.ptsData ?? null,
        raw: data.raw?.data ?? null,
        status: data.status ?? 0
    };
};